import React, { useEffect } from "react";
import { useWizard } from "react-use-wizard";
import NavigateBackWizardStep from "../../components/navigateBackWizardStep";
import MultipleChoice from "./MultipleChoice";
import { useTranslation } from "react-i18next";

const MultiChoiceStep = ({
  question,
  choices,
  initState,
  onSubmitHandler,
  qKey,
  isPillView = false,
}) => {
  const [selectedChoices, setSelectedChoices] = React.useState(
    () => typeof initState === "object" && initState
  );

  const { previousStep, nextStep, goToStep } = useWizard();
  const { t } = useTranslation();

  const getExclusiveOption = () => choices.find((choice) => choice?.exclusive);

  const handleChoiceChange = (choiceCode, isChecked) => {
    const exclusiveOption = getExclusiveOption();

    setSelectedChoices((prev) => {
      const updated = { ...prev };

      // If the selected option is the exclusive one
      if (exclusiveOption?.code === choiceCode && isChecked) {
        // Deselect all other options
        const newState = {
          [choiceCode]: {
            checked: true,
            code: choiceCode,
            value: exclusiveOption.text,
          },
        };
        return newState;
      }

      // If any non-exclusive option is selected, deselect the exclusive one
      if (exclusiveOption && updated[exclusiveOption.code]) {
        updated[exclusiveOption.code] = {
          ...updated[exclusiveOption.code],
          checked: false,
        };
      }

      // Update the selected non-exclusive option
      updated[choiceCode] = {
        ...updated[choiceCode],
        checked: isChecked,
        code: choiceCode,
        value: choices.find((c) => c.code === choiceCode)?.text || "",
      };

      return updated;
    });
  };

  const handleSubmit = () => {
    onSubmitHandler({
      [qKey]: {
        _state: selectedChoices,
      },
    });
    nextStep();
  };

  const handleBackNav = () => {
    previousStep();
  };

  return (
    <>
      <NavigateBackWizardStep
        clickHandler={handleBackNav}
        title={t("title")}
        hideLibrary={true}
      />
      <div className="body_content">
        <div className="inner_body">
          <MultipleChoice
            question={question}
            choices={choices}
            qKey={qKey}
            selectedChoices={selectedChoices || {}}
            onChange={handleChoiceChange}
            onSubmitHandler={handleSubmit}
            isPillView={isPillView}
          />
        </div>
      </div>
    </>
  );
};

export default MultiChoiceStep;
